import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { NeuButton, NeuInput, NeuSelect } from "../../components/neu/Neu";
import { addCustomPerm } from "../../api/permissions";

// نموذج إضافة صلاحية مخصّصة — للأدمن فقط. الوحدة تشمل الأصلية أو "custom".
export const AddCustomPermForm = ({ modules, onAdded }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [module, setModule] = useState("custom");
  const [key, setKey] = useState("");
  const [ar, setAr] = useState("");
  const [en, setEn] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await addCustomPerm({ key, module, label_ar: ar, label_en: en });
      toast.success(t("perms.customAdded"));
      setKey(""); setAr(""); setEn("");
      setOpen(false);
      onAdded && onAdded();
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <NeuButton
        variant="primary"
        className="flex items-center gap-2"
        data-testid="perms-custom-open"
        onClick={() => setOpen(true)}
      >
        <Plus className="h-4 w-4" /> {t("perms.addCustom")}
      </NeuButton>
    );
  }

  return (
    <form onSubmit={submit} className="neu grid gap-3 p-4" data-testid="perms-custom-form">
      <p className="text-sm font-bold">{t("perms.addCustom")}</p>
      <div className="grid gap-3 sm:grid-cols-2">
        <NeuSelect data-testid="perms-custom-module" value={module} onChange={(e) => setModule(e.target.value)}>
          <option value="custom">custom</option>
          {modules.map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </NeuSelect>
        <NeuInput data-testid="perms-custom-key" placeholder="key (e.g. approve_over_100k)" value={key} onChange={(e) => setKey(e.target.value)} required />
        <NeuInput data-testid="perms-custom-ar" placeholder={t("perms.labelAr")} value={ar} onChange={(e) => setAr(e.target.value)} required />
        <NeuInput data-testid="perms-custom-en" placeholder={t("perms.labelEn")} value={en} onChange={(e) => setEn(e.target.value)} required />
      </div>
      <div className="flex justify-end gap-2">
        <NeuButton type="button" data-testid="perms-custom-cancel" onClick={() => setOpen(false)}>
          {t("app.cancel")}
        </NeuButton>
        <NeuButton variant="primary" type="submit" data-testid="perms-custom-save" disabled={busy}>
          {t("app.save")}
        </NeuButton>
      </div>
    </form>
  );
};
